<template>
<b-overlay :show="showOverlay" rounded="sm">
      <b-col class="container text-right"> </b-col>

      <b-card class="mt-2 col-12">
        <b-tabs>
          <b-tab
            v-for="tab in tabs"
            :key="tab.title"
            :title="tab.title"
            lazy
            @click.prevent="setActiveTabName(tab.mode)"
          >
            <b-col cols="12">
              <SearchFilter
                ref="searchFilter"
                :routeName="$route.name"
                :mode="tab.mode"
                @handleSubmit="searchFilterSubmit"
              />
            </b-col>
          </b-tab>
        </b-tabs>
      </b-card>

      <b-col v-for="tab in activeTab" :id="tab" :key="tab" cols="12">
        <commonTable
          ref="tableCommon"
          :routeName="$route.name"
          :tableHeader="tableHeader"
          :searchMode="tab"
          @handleGroup="getManageGroup"
          @handleOverlay="setOverlay"
        />
      </b-col>
    </b-overlay>
</template>

<script>
import {
  BRow,
  BCol,
  BTabs,
  BTab,
  BButton,
  BOverlay,
  BCard,
  BCardHeader,
  BCardBody,
} from "bootstrap-vue";
import commonTable from "@/views/Complaint/components/vueGoodTable/commonTable.vue";
import commonTableHeader from "@/views/Complaint/components/vueGoodTable/commonTableHeader.js";
import SearchFilter from "@/views/Complaint/components/vueGoodTable/SearchFilter.vue";
import * as userData from "@/auth/localStorageUtils.js";
import * as viewStore from "@/store/api/screening/screening.js";

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BTabs,
    BTab,
    BCard,
    BCardHeader,
    BCardBody,
    BOverlay,
    commonTable,
    SearchFilter,
    viewStore,
  },
  data() {
    return {
      tabs: [
        { title: "รายการเรื่องร้องทุกข์", mode: "LawLeaderDept" },
        // { title: 'ประวัติดำเนินการ', mode: 'Group' },
      ],
      activeTab: ["LawLeaderDept"],
      tableHeader: commonTableHeader,
      showOverlay: false,
    };
  },
  methods: {
    setOverlay(isShow) {
      this.showOverlay = isShow;
    },
    setActiveTabName(name) {
      this.activeTab = [];
      this.activeTab.push(name);
    },
    getManageDetail(id) {
      // let routeData = this.$router.resolve({name: 'LawScreeningManage', query: { id:id } });
      // window.open(routeData.href, '_blank');
    },
    getManageGroup(id) {
      // let routeData = this.$router.resolve({name: 'LawGroupdManage' });
      // window.open(routeData.href, '_blank');
      const routeData = this.$router.resolve({
        name: "LawLeaderDeptManage",
        query: { id },
      });
      window.open(routeData.href, "_blank");
    },
    searchFilterSubmit(params) {
      params.departmentId = userData.departmentId();

      console.log("searchFilterSubmit");

      this.$refs.tableCommon[0].onSearchSubmit(params);
    },
    onBtnAddClicked() {
      window.open(
        this.$router.resolve({
          name: "servicecentercomplaint",
          query: { parentComponent: "Deptlist" },
        }).href,
        "_self"
      );
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
